var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.page_count),function(i){return _c('pdf',{key:i,staticStyle:{"display":"inline-block","width":"100%"},attrs:{"src":_vm.computedSourcePath,"page":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }